import type { AuthUser } from "../../lib/api-client.js";

// Cached under the `auth/me` query key alongside the signed-in user /
// null-when-signed-out: the API runs without auth (ADR-011 open mode), so
// there is nobody to sign in.
export const OPEN = "open" as const;

export type MeData = AuthUser | null | typeof OPEN;

export interface AuthView {
  user: AuthUser | null;
  /** False in open mode: no login screen, no logout button. */
  authEnabled: boolean;
  /** True when the dashboard should render: signed in, or auth is off. */
  canView: boolean;
}

export function toAuthView(me: MeData): AuthView {
  if (me === OPEN) return { user: null, authEnabled: false, canView: true };
  return { user: me, authEnabled: true, canView: me !== null };
}
